import { addAlpha } from "common/helpers/colors.helpers";
import React, { CSSProperties } from "react";

interface TagComponentProps {
  color: string;
  style?: CSSProperties;
  children?: React.ReactNode;
}

export const TagComponent: React.FC<TagComponentProps> = ({
  color,
  children,
  style,
}) => {
  return (
    <div
      style={{
        backgroundColor: addAlpha(color, 0.2),
        color: color,
        padding: "8px 16px",
        fontSize: "12px",
        fontWeight: 500,
        borderRadius: "5px",
        ...style,
      }}
    >
      {children}
    </div>
  );
};
